export enum CONTENT_STREAMS {
    /**
     * @value Content stream
     */
    CONTENT_STREAM = 'ADMIN.NAV.MOBILE_SETTINGS_CONTENT_STREAMS',
    /**
     * @value Source site
     */
    SOURCE_SITE = 'ADMIN.CUSTOMER.STREAMS.INSTANCE_LABEL',
    /**
     * @value View mode
     */
    VIEW_MODE = 'ADMIN.CUSTOMER.STREAMS.VIEW_MODE',
    /**
     * @value List
     */
    VIEW_MODE_LIST = 'ADMIN.CUSTOMER.STREAMS.VIEW_MODE_LIST',
    /**
     * @value Spotlight
     */
    VIEW_MODE_SPOTLIGHT = 'ADMIN.CUSTOMER.STREAMS.VIEW_MODE_SPOTLIGHT',
}
